<template>
  <div class="page">
    <div class="page-header">
      <div class="header-text">
        <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
        <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
      </div>
      <img class="header-img" src="../../assets/images/courtage/financement_img.png" />
    </div>
    <div class="page-content">
      <div>
        <div class="flex">
          <div class="img-wrapper">
            <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''">
          </div>
          <div>
            <h3 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h3>
            <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
          </div>
        </div>
        <div class="flex">
          <div class="img-wrapper">
            <img :src="focus.paragraphe2 ? focus.paragraphe2.image : ''">
          </div>
          <div>
            <h3 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h3>
            <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
          </div>
        </div>
        <div class="flex">
          <div class="img-wrapper">
            <img :src="focus.paragraphe3 ? focus.paragraphe3.image : ''">
          </div>
          <div>
            <h3 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h3>
            <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
          </div>
        </div>
        <div class="flex">
          <div class="img-wrapper">
            <img :src="focus.paragraphe4 ? focus.paragraphe4.image : ''">
          </div>
          <div>
            <h3 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h3>
            <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
          </div>
        </div>
        <div class="flex">
          <div class="img-wrapper">
            <img :src="focus.paragraphe5 ? focus.paragraphe5.image : ''">
          </div>
          <div>
            <h3 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h3>
            <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
          </div>
        </div>
      </div>
      <div class="financement-form-container">
        <div>
          <h4 v-html="focus.formulaire ? focus.formulaire.titre : ''"></h4>
          <p v-html="focus.formulaire ? focus.formulaire.texte : ''"></p>
          <router-link :to="{ name: 'DemandePretForm' }">
            <button class="cg-btn cg-btn-primary">Quelle est votre situation ?</button>
          </router-link>
        </div>
        <img src="../../assets/images/courtage/mask@3x.webp">
        <img class="icn-timer" src="../../assets/icons/icn-timer.svg">
      </div>
    </div>
    <site-link siteName="Courtage"></site-link>
  </div>
</template>

<script>
import { getFocus } from '../../mixins/getFocus'
import SiteLink from '../Components/SiteLink.vue'

export default {
  name: 'Financement',
  mixins: [getFocus],
  components: {
    SiteLink
  },
  data() {
    return {
      focus: {}
    }
  },
  async beforeMount() {
    await this.getFocus('cg', 'Financement Immo & Pro')
      .then(res => {
        this.focus = res
      })
  }
}
</script>

<style lang="scss" scoped>
.header-img{
  height: auto !important;
}
.page-content {

  .flex {
    display: flex;
    margin: 16px 0;
  }
  .img-wrapper {
    align-items: center;
    margin-right: 32px;
    width: auto;

    img {
      width: auto;
      height: 71px;
    }
  }
  .financement-form-container {
    position: relative;
    margin: 64px 0;
    width: 100%;
    background-color: var(--color-background-dark);
    border-radius: 10px;
    box-shadow: 2px 21px 20px -9px rgba(0, 0, 0, 0.3);
    color: white;
    display: flex;
    justify-content: space-between;

    &>div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      padding: 80px;
      width: 50%;
    }

    &>img {
      height: 100%;
      width: 50%;
      border-radius: 0px;
    }

    .icn-timer {
      position: absolute;
      top: calc(50% - 76px);
      left: calc(50% - 76px);
      height: 152px;
      width: 152px;
    }
  }
}

@media (max-width: 1150px) {
  .page-content {
    .financement-form-container {
      img, .icn-timer {
        display: none;
      }
      &>div {
        width: 100%;
        align-items: center;
      }
    }
  }
}

</style>
